export const ensureUiState = (state, initialState) => {
  if (!state.ui) {
    state.ui = { ...initialState.ui };
  }
};

export const getPreserveFacetsForFilterOut = ({
  isNewPage,
  itemCount,
  stateSnapshot,
  hasFilterReturnedNoResults,
}) =>
  !isNewPage && hasFilterReturnedNoResults(itemCount, stateSnapshot)
    ? {
        facets: stateSnapshot.facets,
      }
    : null;
